import classNames from 'classnames';
import { FC } from 'react';

import styles from './productCardSkeleton.module.scss';

interface ProductCardSkeletonProps {
  className?: string;
}

export const ProductCardSkeleton: FC<ProductCardSkeletonProps> = ({ className }) => {
  return (
    <article aria-hidden="true" className={classNames(styles.skeleton, className)}>
      <div className={styles.skeleton__image} />
      <div className={styles.skeleton__content}>
        <div className={styles.skeleton__category} />
        <div className={styles.skeleton__title} />
        <div className={styles.skeleton__title_short} />
        <div className={styles.skeleton__price_row}>
          <div className={styles.skeleton__price} />
          <div className={styles.skeleton__old_price} />
        </div>
      </div>
      <div className={styles.skeleton__bottom}>
        <div className={styles.skeleton__dropdown} />
        <div className={styles.skeleton__button} />
      </div>
    </article>
  );
};
